module.exports = __webpack_public_path__ + "img/688-21dcf1.png";